import React from "react";
import AllRoutes from "./Navigation/Routes";

const App = () => {
  return (
    <div className="App">
      <AllRoutes/>
    </div>
  )
}

export default App;
